import React from 'react';

import type { Apollo as ApolloTypes } from 'src/gql/generated';

import { PhaseTaskRow } from './PhaseTaskRow';
import type { ParkedWorkflowMeta } from '../use-parked-workflow-completion';

type PhaseTask = ApolloTypes.PhaseSimple_NonSigningPhase_Fragment['tasks'][number];

interface PhaseTaskRowWithSubtasksProps {
  phase: ApolloTypes.PhaseSimple_NonSigningPhase_Fragment;
  readOnly: boolean;
  row: { subtasks: PhaseTask[]; task: PhaseTask };
  workflow: ParkedWorkflowMeta;
  hideStatus?: boolean;
}

// A root task's row followed by its subtasks' indented rows.
export const PhaseTaskRowWithSubtasks = React.memo(function PhaseTaskRowWithSubtasks({
  hideStatus,
  phase,
  readOnly,
  row,
  workflow,
}: PhaseTaskRowWithSubtasksProps) {
  return (
    <>
      <PhaseTaskRow
        hideStatus={hideStatus}
        phase={phase}
        readOnly={readOnly}
        task={row.task}
        workflow={workflow}
      />
      {row.subtasks.map(subtask => (
        <PhaseTaskRow
          key={subtask.id}
          isSubtask
          phase={phase}
          readOnly={readOnly}
          task={subtask}
          workflow={workflow}
        />
      ))}
    </>
  );
});
